import React from 'react';
import TextField from '@material-ui/core/TextField';
import { ThemeProvider } from '@material-ui/core/styles';
import * as buttonStyles from '../styles/Button.module.scss';
import * as styles from './styles/styles.module.scss';
import theme from '../../shared/MaterialTheme';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import Toggle from '../../shared/Toggle';

class CreateNewList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      privateList: false,
      newListTitle: null
    };
    this.handleChangeListTitle = this.handleChangeListTitle.bind(this);
    this.handleCreateNewList = this.handleCreateNewList.bind(this);
    this.togglePrivacy = this.togglePrivacy.bind(this);
  }

  togglePrivacy() {
    this.setState({ privateList: !this.state.privateList });
  }

  handleCreateNewList() {
    const baseUrl = '/api/alltrails/lists';
    const listTitle = this.state.newListTitle;
    if (listTitle.trim().length == 0) {
      return false;
    }

    const handleListAddedSuccess = (data, success) => {
      if (!success) {
        return;
      }
      // add new list
      if (this.props.handleListCreated) {
        const list = data.lists[0];
        list.list_id = list.id;
        list.list_slug = list.slug;
        list.title = list.name;
        this.props.handleListCreated(list);
      }
      // reset new list title
      this.setState({ newListTitle: null });
      // scroll to top of table
      if (this.props.tableRef) {
        this.props.tableRef.current.scrollTop = 0;
      }
    };
    const handleListAddedError = (xhr, status, error) => {
      alert('There was an error creating your list');
      console.error(error);
    };
    const handleListAddedComplete = () => {};

    ServerCommunicationUtil.postApiEndpoint(
      baseUrl,
      {
        name: listTitle,
        private: this.state.privateList
      },
      handleListAddedSuccess,
      handleListAddedError,
      handleListAddedComplete
    );
    ServerCommunicationUtil.handleGaqPush(['_trackEvent', 'Save To List Modal', 'List Added']);
    return false;
  }

  handleChangeListTitle(e) {
    this.setState({ newListTitle: e.target.value });
  }

  render() {
    if (!this.props.edit) {
      return (
        <div className={styles.createNew}>
          <span className={styles.createNewList} onClick={this.props.handleEditClick} data-testid="createNewListButton">
            {StringConstantsMixin.strings.LIST_MODAL.CREATE_NEW_LIST}
          </span>
        </div>
      );
    }
    const saveDisabled = !this.state.newListTitle || !this.state.newListTitle.length;
    return (
      <div className={styles.createNew}>
        <ThemeProvider theme={theme}>
          <TextField
            className={styles.input}
            data-testid="createNewListTextField"
            color="secondary"
            label={StringConstantsMixin.strings.LIST_MODAL.NAME_YOUR_LIST}
            variant="outlined"
            onKeyUp={e => {
              if (e.keyCode === 13) {
                this.handleCreateNewList();
              }
            }}
            onChange={this.handleChangeListTitle}
          />
          <div>
            <Toggle
              inputId="listPrivacyToggle"
              label={StringConstantsMixin.strings.PRIVATE_LIST}
              onChange={this.togglePrivacy}
              checked={this.state.privateList}
              showLabelFirst
            />
          </div>
          <div className={styles.btns}>
            <button className={`${styles.btn} ${buttonStyles.secondary}`} onClick={this.props.handleCancelClick} data-testid="createNewListCancel">
              {StringConstantsMixin.strings.CANCEL}
            </button>
            <button
              className={`${styles.btn} ${buttonStyles.primary}`}
              disabled={saveDisabled}
              onClick={this.handleCreateNewList}
              data-testid="createNewListCreate"
            >
              {StringConstantsMixin.strings.CREATE}
            </button>
          </div>
        </ThemeProvider>
      </div>
    );
  }
}

export default CreateNewList;
